import React from "react";
import styles from "../../../../../css/index.css";
import SectionGroup, { SectionColumn, SectionGroupRow } from "../SectionGroup/index.js";
import SectionItem from "../SectionItem/index.js";
import { useTKHost } from "../../HostContext.js";
const ProductsSection = () => {
  const tkHost = useTKHost();
  return /*#__PURE__*/React.createElement(SectionGroup, {
    title: "Planning & Inspiration",
    className: styles.productsSection,
    trackableProps: {
      selection: 'planning'
    }
  }, /*#__PURE__*/React.createElement(SectionGroupRow, null, /*#__PURE__*/React.createElement(SectionColumn, null, /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/gs/wedding-websites`
  }, "Wedding websites"), /*#__PURE__*/React.createElement(SectionItem, {
    className: styles.sectionItem,
    href: `${tkHost}/registry`
  }, "Registry"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/marketplace`
  }, "Marketplace"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/paper/invitations/wedding`
  }, "Wedding invitations"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/wedding-planning-app`
  }, "Get The Knot app"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/wedding-budget`
  }, "Wedding budget"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/wedding-checklist`
  }, "Wedding checklist"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/gs/guest-list`
  }, "Wedding guest list")), /*#__PURE__*/React.createElement(SectionColumn, null, /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/content`,
    trackableProps: {
      selection: 'wedding etiquette'
    }
  }, "Wedding ideas & etiquette"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/content/getting-engaged-advice`
  }, "Engagement"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/content/wedding-rehearsal-party-advice`,
    trackableProps: {
      selection: 'parties events'
    }
  }, "Parties & events"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/fashion/wedding-dresses`,
    trackableProps: {
      selection: 'wedding dresses'
    }
  }, "Wedding dresses"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/content/wedding-gift-favor-advice`
  }, "Gifts"), /*#__PURE__*/React.createElement(SectionItem, {
    href: `${tkHost}/real-weddings/photos`
  }, "Real Wedding photos"), /*#__PURE__*/React.createElement(SectionItem, {
    href: "https://forums.theknot.com/community"
  }, "Community"))));
};
export default ProductsSection;